import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-[1000px] mx-auto">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-3xl font-heading text-foreground-950 mb-4">
              {appData.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              {appData.description}
            </p>
            <div className="flex flex-wrap gap-3 justify-center lg:justify-start">
              {appData.features.map((f, i) => (
                <span
                  key={i}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-background-100 border border-background-200/70 rounded-full text-xs text-foreground-600 whitespace-nowrap"
                >
                  <i className="ri-check-line text-primary-500 text-sm"></i>
                  {f}
                </span>
              ))}
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="relative w-[240px] h-[480px] rounded-[2rem] border-4 border-foreground-900 bg-foreground-900 overflow-hidden">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[100px] h-7 bg-foreground-900 rounded-b-2xl z-10"></div>
              <div className="w-full h-full bg-background-100 p-3 pt-10 flex flex-col gap-2">
                <div className="w-full h-32 rounded-lg bg-primary-100 flex items-center justify-center">
                  <i className="ri-play-circle-line text-primary-500 text-3xl"></i>
                </div>
                <div className="w-full h-3 rounded-full bg-background-200"></div>
                <div className="w-3/4 h-3 rounded-full bg-background-200"></div>
                <div className="w-full h-24 rounded-lg bg-background-200 mt-2"></div>
                <div className="w-full h-2 rounded-full bg-background-200 mt-1"></div>
                <div className="w-2/3 h-2 rounded-full bg-background-200"></div>
                <div className="flex-1"></div>
                <div className="w-full h-10 rounded-lg bg-primary-500 flex items-center justify-center">
                  <span className="text-background-50 text-xs font-semibold">立即播放</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}